var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[(_vm.showSpinner)?_c('mdb-col',[_c('Spinner')],1):_vm._e(),_c('mdb-row',[_c('AssetStateForm',{on:{"asset-state-created":_vm.onAssetStateCreated}})],1),_c('mdb-row',[_c('AssetStateList',{attrs:{"assetStates":_vm.assetStates}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }